module.exports = __webpack_public_path__ + "img/4_1.df6cb311.png";